module.exports = __webpack_public_path__ + "static/assets/94e4c0b8d0f84e8554b962005f2db4df.svg";